import type { JobPhase } from '@prisma/client';
import { getJobPhaseDisplayText, JOB_PHASE_BADGE_COLORS } from './JobPhaseBadge';

interface PhaseIdBadgeProps {
	jobId: number;
	jobPhase: JobPhase;
	containerClass?: string;
	mtEnabled?: boolean;
}

const PhaseIdBadge = ({ jobId, jobPhase, containerClass = '', mtEnabled = true }: PhaseIdBadgeProps) => {
	const { background, border } = JOB_PHASE_BADGE_COLORS[jobPhase];

	return (
		<div className={`${mtEnabled ? 'mt-1' : ''} flex items-center ${containerClass}`}>
			<div
				className={`whitespace-nowrap text-xs font-medium border ${border} border-r-0 bg-gray-100 text-gray-600 h-full rounded-l-md py-0.5 px-1.5`}
			>
				ID: {jobId}
			</div>
			<div
				className={`border ${border} ${background} inline-flex items-center justify-center rounded-r-full px-1.5 py-0.5 text-xs font-medium text-center whitespace-nowrap`}
			>
				{getJobPhaseDisplayText(jobPhase)}
			</div>
		</div>
	);
};

export default PhaseIdBadge;
